











import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { IDocumentImageSource, ImageKinds } from "../../../../domain/document";
import { MovableImageItem } from "../../../../domain/document/items";
import { PropertyEditableMixin, NewObjectLocatableMixin } from "./mixins";
import ImageFileUploader from "../ImageFileUploader.vue";
import ImageLocatorMenu from "./ImageLocatorMenu.vue";
import MovableImagePropertyEditor from "./MovableImagePropertyEditor.vue";
import { Size } from "../../../../domain/drawing";

@Component({
  components: {
    uploader: ImageFileUploader,
    imageLocatorMenu: ImageLocatorMenu,
    propertyEditor: MovableImagePropertyEditor,
  },
})
export default class NewImagePropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin) {
  editingSource: MovableImageItem;
  shouldLocate: boolean;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  async mounted(): Promise<void> {
    this.editingSource = await this.createSource();
  }

  data(): any {
    return {
      shouldLocate: false,
    };
  }

  private changeProcess(): void {
    const image = this.$refs.preview as HTMLImageElement;
    if (!image) {
      return;
    }
    if (this.editingSource) {
      this.writeProperty(s => s.geometry.rectangle.size = this.shouldLocate ? new Size(image.naturalWidth, image.naturalHeight) : new Size(0, 0));
    }
    this.process = this.shouldLocate
    ? this.locate
    : () => this.layoutAspectRatioFixedRectangle(image.naturalWidth / image.naturalHeight, 20, 20);
  }

  get imageSource(): IDocumentImageSource {
    return this.editingSource
      ? this.editingSource.imageSource
      : undefined;
  }

  set imageSource(source: IDocumentImageSource) {
    this.writeProperty((s: MovableImageItem) => {
      s.clearImageInformation();
      s.replaceImageSource(source);
      s.imageKind = ImageKinds.Image;
    });
    this.process = null;
  }

  get isImageUploaded(): boolean {
    return !!this.imageSource && !!this.imageSource.source;
  }

  onImageLoaded(): void {
    this.changeProcess();
  }

  @Watch("shouldLocate")
  onShouldLocateUpdated(newValue: boolean, oldValue: boolean) {
    this.changeProcess();
  }
}
